import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { putCategoriaProducto } from "../helpers/rutaCategoriasProductos";
import "animate.css";

const clean = (v) => String(v ?? "").trim();

const normalizarCodigo = (v) =>
  clean(v)
    .toUpperCase()
    .replace(/\s+/g, "_")
    .replace(/[^A-Z0-9_]/g, "");

const initial = {
  codigo: "",
  nombre: "",
  descripcion: "",
  grupoRecepcion: "OTRO",
  limitePorReceptorPorVenta: 0,
  usaColorDefault: false,
  activo: true,
};

const ModalFormCategoriaProducto = ({ categoria, handleClose }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const data = categoria?.categoria || categoria || {};

  const [formValues, setFormValues] = useState(initial);

  useEffect(() => {
    setFormValues({
      codigo: clean(data?.codigo).toUpperCase(),
      nombre: clean(data?.nombre).toUpperCase(),
      descripcion: clean(data?.descripcion).toUpperCase(),
      grupoRecepcion: clean(data?.grupoRecepcion || "OTRO").toUpperCase(),
      limitePorReceptorPorVenta: Number(data?.limitePorReceptorPorVenta || 0),
      usaColorDefault: Boolean(data?.usaColorDefault),
      activo: data?.activo ?? true,
    });
  }, [categoria]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "codigo") {
      setFormValues((prev) => ({
        ...prev,
        codigo: normalizarCodigo(value),
      }));
      return;
    }

    if (name === "nombre") {
      setFormValues((prev) => ({
        ...prev,
        nombre: value.toUpperCase(),
      }));
      return;
    }

    if (name === "descripcion") {
      setFormValues((prev) => ({
        ...prev,
        descripcion: value.toUpperCase(),
      }));
      return;
    }

    if (name === "grupoRecepcion") {
      const grupo = clean(value).toUpperCase();

      setFormValues((prev) => {
        let limite = prev.limitePorReceptorPorVenta;
        let usaColor = prev.usaColorDefault;

        if (grupo === "VEHICULO") {
          limite = 1;
          usaColor = true;
        }

        if (grupo === "ENERGIA") {
          limite = 0;
          usaColor = false;
        }

        return {
          ...prev,
          grupoRecepcion: grupo,
          limitePorReceptorPorVenta: limite,
          usaColorDefault: usaColor,
        };
      });

      return;
    }

    if (type === "checkbox") {
      setFormValues((prev) => ({
        ...prev,
        [name]: checked,
      }));
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const id = data?._id || categoria?._id;

    if (!id) return "No se encontró el id de la categoría.";
    if (!normalizarCodigo(formValues.codigo)) return "Ingresá el código.";
    if (!clean(formValues.nombre)) return "Ingresá el nombre.";

    if (Number(formValues.limitePorReceptorPorVenta || 0) < 0) {
      return "El límite por receptor no puede ser negativo.";
    }

    return "";
  };

  const buildPayload = () => {
    return {
      codigo: normalizarCodigo(formValues.codigo),
      nombre: clean(formValues.nombre).toUpperCase(),
      descripcion: clean(formValues.descripcion).toUpperCase(),
      grupoRecepcion: clean(formValues.grupoRecepcion || "OTRO").toUpperCase(),
      limitePorReceptorPorVenta: Number(
        formValues.limitePorReceptorPorVenta || 0
      ),
      usaColorDefault: Boolean(formValues.usaColorDefault),
      activo: formValues.activo ?? true,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const msg = validate();
    if (msg) return alert(msg);

    const id = data?._id || categoria?._id;
    const payload = buildPayload();

    try {
      const resp = await putCategoriaProducto(id, payload);

      console.log("✅ Categoría actualizada:", resp);

      if (resp?.ok === false) {
        alert(
          resp?.error?.message ||
            resp?.error ||
            "No se pudo actualizar la categoría"
        );
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 1200);
    } catch (error) {
      console.error("❌ Error al guardar categoría:", error?.response?.data || error);
      alert("Error al guardar categoría");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="form-group mt-3">
            <label>Código</label>
            <input
              type="text"
              className="form-control"
              name="codigo"
              maxLength="40"
              required
              value={formValues.codigo}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Nombre</label>
            <input
              type="text"
              className="form-control"
              name="nombre"
              maxLength="80"
              required
              value={formValues.nombre}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Grupo recepción</label>
            <select
              className="form-control"
              name="grupoRecepcion"
              value={formValues.grupoRecepcion}
              onChange={handleChange}
              required
            >
              <option value="VEHICULO">VEHÍCULO</option>
              <option value="ENERGIA">ENERGÍA</option>
              <option value="ACCESORIO">ACCESORIO</option>
              <option value="REPUESTO">REPUESTO</option>
              <option value="OTRO">OTRO</option>
            </select>
          </div>

          <div className="form-group mt-3">
            <label>Descripción</label>
            <input
              type="text"
              className="form-control"
              name="descripcion"
              maxLength="150"
              value={formValues.descripcion}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3">
            <label>Límite por receptor por venta</label>
            <input
              type="number"
              className="form-control"
              name="limitePorReceptorPorVenta"
              min="0"
              value={formValues.limitePorReceptorPorVenta}
              onChange={handleChange}
            />
            <small className="text-muted">
              0 = sin límite. Para motos/triciclos usar 1.
            </small>
          </div>

          <div className="form-group mt-3">
            <label>Usa color por defecto</label>

            <div
              className="form-control d-flex align-items-center"
              style={{ height: 38 }}
            >
              <Form.Check
                type="checkbox"
                name="usaColorDefault"
                label="Sí"
                checked={Boolean(formValues.usaColorDefault)}
                onChange={handleChange}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormCategoriaProducto;